<template>
	<div class="sm-mt">
		<p v-if="secondActive || firstActive">{{ strings.queryMainDesc }}</p>
		<div v-if="firstActive">
			<strong>{{ strings.queryGroup }}</strong>
			<sm-group-button v-for="(tag, index) in qb" :key="tag.id" :icon="tag[1]" :group="index" @groups="stepMethods(index, tag.id)">{{ tag.name }}</sm-group-button>
		</div>
		<div v-if="secondActive">
			<strong>{{ strings.queryMethod }}</strong>
			<sm-group-button v-for="(tag, index) in qb[currentGroup].methods" :key="tag.name" :icon="tag[1]" :group="index" @groups="stepArgs(tag.name, tag.method, tag.type)">{{ tag.name }}</sm-group-button>
		</div>
		<div v-if="thirdActive">
			<p>{{ strings.queryArgs }} <strong>{{ currentName }} ( {{ currentMethod }} )</strong>:</p>
			<p class="description">{{ strings.queryDesc }}
				<span class="sm-inline-attr sm-inline-attr-query" v-for="(param, index) in params" :key="param.name"><strong>{[ {{ param.name }} ]}</strong></span>
			</p>
			<p class="description sm-pb30">{{ strings.queryDescCP }}</p>
			<div>
				<input v-if="defaultInput" type="text" ref="inputValueArg" :placeholder="valuePlaceholder" v-model="valueInput" @keydown="errorShow = false">
				<p class="description" v-html="currentDesc"></p>
			</div>
			<sm-tree-input v-if="currentType == 'taxonomy' || currentType == 'meta' || currentType == 'date'" 
			component-id="query-tree" 
			@changed="emitChanges" 
			:button-title="treeData.buttonTitle" 
			:def="defQuery" 
			:def-data="treeData.defs" 
			:event-query="treeData.queryName"
			></sm-tree-input>
			<button v-if="defaultInput" @click="addValue" type="button" class="sm-button sm-edit-button"><i class="icon-plus"></i><span v-if="editMode">{{ editTitle }}</span><span v-else="editMode">{{ addTitle }}</span> {{ buttonTitle }}</button>
			<transition name="fade">
				<span class="sm-error" v-if="errorShow">{{ errorMsg }}</span>
			</transition>
		</div>
		<div class="sm-mt10">
			<button v-if="secondActive | thirdActive" @click="backStep" type="button" class="sm-button sm-loop-button">
				<i class="icon-level-up"></i>{{ backTitle }}
			</button>
		</div>
		<ul class="sm-list">
			<li class="sm-mr10" v-for="(row, index) in values" :key="row.id">
				<a href="#" style="top:1px;margin-left:4px;" class="sm-edit sm-edit-flat" :title="editTitle" @click.prevent="editRow(index)"><span class="icon-pencil"></span></a>
				<a href="#" class="sm-delete sm-delete-flat" :title="deleteTitle" @click.prevent="deleteRow(index)">
					<span style="top:2px;left:-4px" class="icon-cancel sm-lg"></span>
				</a>
				<span class="value" style="left:-3px;position:relative;">{{ row }}</span>
			</li>	
		</ul>
	</div>
</template>

<script>
import bus from './Bus.js';
import smTreeInput from './TreeInput.vue';
import smGroupButton from './GroupButton.vue';
export default {
	components: {
		smTreeInput,
		smGroupButton
	},
	props: {
		componentId: String,
		valuePlaceholder: String,
		buttonTitle: String,
		backTitle: String,
		qb: {
			type: Array,
			default: function() {
				return [];
			}
		},
		params: Array
	},
	data: function() {
		return {
			values: [],
			valueInput: '',
			currentID: '',
			currentGroup: '',
			currentMethod: '',
			currentName: '',
			currentType: '',
			currentDesc: '',
			editTitle: sm.editTitle,
			deleteTitle: sm.deleteTitle,
			addTitle: sm.addTitle,
			editMode: false,
			firstActive: true,
			secondActive: false,
			thirdActive: false,
			defaultInput: true,
			isActiveStep1: 'active',
			isActiveStep2: '',
			isActiveStep3: '',
			errorMsg: '',
			errorShow: false,
			defQuery: {},
			strings: {
				'queryMainDesc': sm.queryMainDesc,
				'step1': sm.step1,
				'step2': sm.step2,
				'step3': sm.step3,
				'queryGroup': sm.queryGroup,
				'queryMethod': sm.queryMethod,
				'queryArgs': sm.queryArgs,
				'queryDesc': sm.queryDesc,
				'queryDescCP': sm.queryDescCP
			}
		};
	},
	mounted: function() {
		var self = this;
		bus.$on('editCurrentArg', function(id, row) {
			if (self.componentId == id) {
				self.currentType = null;
				self.currentDesc = '';
				self.defaultInput = true;
				self.isActiveStep1 = 'active';
				self.isActiveStep2 = 'active';
				self.isActiveStep3 = 'active';
				self.firstActive = false;
				self.secondActive = false;
				self.thirdActive = true;
				for (var i = 0; i < self.qb.length; i++) {
					for (var g = 0; g < self.qb[i].methods.length; g++) {
						if (self.qb[i].methods[g].method == row.name) {
							self.currentGroup = i;
							self.currentMethod = row.name;
							self.currentID = self.qb[i].id;
							self.currentName = self.qb[i].methods[g].name;
							self.currentType = self.qb[i].methods[g].type;
							if (self.currentType == 'taxonomy' || self.currentType == 'meta' || self.currentType == 'date') self.defaultInput = false;
							if (self.currentType == 'year' || self.currentType == 'month' || self.currentType == 'day' || self.currentType == 'week' || self.currentType == 'hour' || self.currentType == 'minute' || self.currentType == 'second' || this.currentType == 'yearmonth') {
								var desc = self.currentType + 'Desc';
								self.currentDesc = sm[desc];
							}
							self.parseValue(row.value, self.qb[i].methods[g].type);
						}
					}
				}
			}
		});
		bus.$on('deleteCurrentArg', function(id, row) {
			if (self.componentId == id) {
				if (self.thirdActive && self.currentMethod == row.name) {
					self.values = [];
					self.defQuery = {};
					bus.$emit('updateValues', 'query-tree', self.defQuery);
				}
			}
		});
	},
	computed: {
		treeData: function() {
			var obj = {};
			switch (this.currentType) {
				case 'taxonomy':
					obj.buttonTitle = sm.buttonTax;
					obj.defs = {
						'taxonomy': {
							'type': 'string',
							'title': sm.taxTitle,
							'placeholder': sm.taxPlaceholder,
							'desc': sm.taxDesc,
							'req': true,
							'input': true
						},
						'field': {
							'type': 'param',
							'title': sm.fieldTitle,
							'values': ['term_id', 'name', 'slug', 'term_taxonomy_id']
						},
						'terms': {
							'type': 'array',
							'title': sm.termsTitle,
							'placeholder': sm.termsPlaceholder,
							'desc': sm.termsDesc,
							'req': true,
							'input': true
						},
						'operator': {
							'type': 'param',
							'title': sm.operatorTitle,
							'values': ['IN', 'NOT IN', 'AND', 'EXISTS', 'NOT EXISTS']
						},
						'include_children': {
							'type': 'param',
							'title': sm.includeTitle,
							'values': ['TRUE', 'FALSE']
						}
					};
					obj.queryName = 'tax_query';
					break;
				case 'meta':
					obj.buttonTitle = sm.buttonMeta;
					obj.defs = {
						'key': {
							'type': 'string',
							'title': sm.keyTitle,
							'placeholder': sm.metaPlaceholder,
							'desc': sm.metaKeyDesc,
							'req': true,
							'input': true
						},
						'value': {
							'type': 'array',
							'title': sm.valueTitle,
							'placeholder': sm.metaValuesPlaceholder,
							'desc': sm.metaValueDesc,
							'input': true
						},
						'compare': {
							'type': 'param',
							'title': sm.compareTitle,
							'values': ['=', '!=', '>', '>=', '<', '<=', 'LIKE', 'NOT LIKE', 'IN', 'NOT IN', 'BETWEEN', 'NOT BETWEEN', 'EXISTS', 'NOT EXISTS', 'REGEXP', 'NOT REGEXP', 'RLIKE']
						},
						'type': {
							'type': 'param',
							'title': sm.typeTitle,
							'values': ['CHAR', 'NUMERIC', 'BINARY', 'DATE', 'DATETIME', 'DECIMAL', 'SIGNED', 'TIME', 'UNSIGNED']
						}
					};
					obj.queryName = 'meta_query';
					break;
				case 'date':
					obj.buttonTitle = sm.buttonDate;
					obj.defs = {
						'year': {
							'type': 'intarray',
							'title': sm.yearTitle,
							'placeholder': sm.yearPlaceholder,
							'desc': sm.yearDesc,
							'reg': /^((19|20)\d{2}|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true,
						},
						'month': {
							'type': 'intarray',
							'title': sm.monthTitle,
							'placeholder': sm.monthPlaceholder,
							'desc': sm.monthDesc,
							'reg': /^(1[0-2]|[1-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true,
						},
						'week': {
							'type': 'intarray',
							'title': sm.weekTitle,
							'placeholder': sm.weekPlaceholder,
							'desc': sm.weekDesc,
							'reg': /^(5[0-3]|[1-4][0-9]|[0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true,
						},
						'day': {
							'type': 'intarray',
							'title': sm.dayTitle,
							'placeholder': sm.dayPlaceholder,
							'desc': sm.dayDesc,
							'reg': /^([1-9]|[1-2][0-9]|3[0-1]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true,
						},
						'dayofyear': {
							'type': 'intarray',
							'title': sm.dayOfYearTitle,
							'placeholder': sm.dayOfYearPlaceholder,
							'desc': sm.dayOfYearDesc,
							'reg': /^([1-9]|[1-9][0-9]|[1-2][0-9][0-9]|3[0-6][0-6]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true,
						},
						'dayofweek': {
							'type': 'intarray',
							'title': sm.dayOfWeekTitle,
							'placeholder': sm.dayOfWeekPlaceholder,
							'desc': sm.dayOfWeekDesc,
							'reg': /^([1-7]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'dayofweek_iso': {
							'type': 'intarray',
							'title': sm.dayOfWeekIsoTitle,
							'placeholder': sm.dayOfWeekIsoPlaceholder,
							'desc': sm.dayOfWeekIsoDesc,
							'reg': /^([1-7]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'hour': {
							'type': 'intarray',
							'title': sm.hourTitle,
							'placeholder': sm.hourPlaceholder,
							'desc': sm.hourDesc,
							'reg': /^(2[0-3]|1[0-9]|[0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'minute': {
							'type': 'intarray',
							'title': sm.minuteTitle,
							'placeholder': sm.minutePlaceholder,
							'desc': sm.minuteDesc,
							'reg': /^(5[0-9]|[0-9]|[1-4][0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'second': {
							'type': 'intarray',
							'title': sm.secondTitle,
							'placeholder': sm.secondPlaceholder,
							'desc': sm.secondDesc,
							'reg': /^(5[0-9]|[0-9]|[1-4][0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'after': {
							'type': 'date',
							'title': sm.afterDateTitle,
							'placeholder': sm.afterDatePlaceholder,
							'desc': sm.afterDateDesc,
							'input': true
						},
						'before': {
							'type': 'date',
							'title': sm.beforeDateTitle,
							'placeholder': sm.beforeDatePlaceholder,
							'desc': sm.beforeDateDesc,
							'input': true
						},
						'column': {
							'type': 'param',
							'title': sm.columnDateTitle,
							'values': ['post_date', 'post_date_gmt', 'post_modified', 'post_modified_gmt', 'comment_date', 'comment_date_gmt', 'user_registered', 'registered', 'last_updated']
						},
						'compare': {
							'type': 'param',
							'title': sm.compareTitle,
							'values': ['=', '!=', '>', '>=', '<', '<=', 'IN', 'NOT IN', 'BETWEEN', 'NOT BETWEEN']
						},
						'inclusive': {
							'type': 'param',
							'title': sm.inclusiveTitle,
							'values': ['FALSE', 'TRUE']
						}
					};
					obj.queryName = 'date_query';
					break;
			}
			return obj;
		},
		currentFlat: function() {
			var str = '';
			var self = this;
			switch (this.currentType) {
                case "year":
                case "month":
                case "week":
                case "day":
                case "hour":
                case "minute":
                case "second":
                case "yearmonth":
				case 'string':
					for (var i = 0; i < this.values.length; i++) {
						str += this.values[i];
						if (i != (self.values.length - 1)) str += ',';
					}
					break;
				case 'array':
					if (this.values.length > 0) str += '{';
					for (var i = 0; i < this.values.length; i++) {	
						str += '"' + i + '":"' + this.values[i] + '"';
						if (i != (self.values.length - 1)) str += ',';
					}
					if (this.values.length > 0) str += '}';
					break;
			}
			return str;
		}
	},
	methods: {
		backStep: function() {
			if (this.secondActive) {
				this.secondActive = false;
				this.firstActive = true;
				this.isActiveStep2 = '';
				this.currentGroup = '';
				this.currentID = '';
			}
			if (this.thirdActive) {
				this.values = [];
				this.valueInput = '';
				this.thirdActive = false;
				this.defaultInput = true;
				this.secondActive = true;
				this.isActiveStep3 = '';
				this.currentMethod = '';
				this.currentType = '';
				this.currentName = '';
				this.currentDesc = '';
				this.errorShow = false;
			}
		},
		stepMethods: function(group, id) {
			this.currentID = id;
			this.currentGroup = group;
			this.firstActive = false;
			this.secondActive = true;
			this.isActiveStep2 = 'active';
		},
		stepArgs: function(name, method, type) {
			this.currentName = name;
			this.currentMethod = method;
			this.currentType = type;
			this.secondActive = false;
			this.thirdActive = true;
			this.isActiveStep3 = 'active';
			if (this.currentType == 'taxonomy' || this.currentType == 'meta' || this.currentType == 'date') this.defaultInput = false;
			if (this.currentType == 'year' || this.currentType == 'month' || this.currentType == 'day' || this.currentType == 'week' || this.currentType == 'hour' || this.currentType == 'minute' || this.currentType == 'second' || this.currentType == 'yearmonth') {
				var desc = this.currentType + 'Desc';
				this.currentDesc = sm[desc];
			}
			this.defQuery = {};
			this.$emit('check', method);
		},
		emitChanges: function(flat, method) {
			var value = {};
			if ((flat && this.currentType == 'taxonomy') || (flat && this.currentType == 'meta') || (flat && this.currentType == 'date')) {
				value = JSON.parse(flat);
				this.defQuery = value;
			}
			this.$emit('changed', flat, method);
		},
		addValue: function() {
			var self = this;
			if (this.validate()) {
				if (!this.editMode) {
					this.values.push(this.valueInput);
				} else {
					Vue.set(this.values, this.currentIndex, this.valueInput);
					this.editMode = false;
				}
				this.valueInput = '';
				this.$refs.inputValueArg.focus();
				self.emitChanges(self.currentFlat, self.currentMethod);
			}
		},
		deleteRow: function(index) {
			this.values.splice(index, 1);
			this.emitChanges(this.currentFlat, this.currentMethod);
		},
		editRow: function(index) {
			this.currentIndex = index;
			this.editMode = true;
			this.valueInput = this.values[index];
			this.$refs.inputValueArg.focus();
		},
		parseValue: function(value, type) {
			var self = this;
			this.values = [];
			switch (type) {
                case "year":
                case "month":
                case "week":
                case "day":
                case "hour":
                case "minute":
                case "second":
                case "yearmonth":
				case 'string':
					value = value.split(',');
					if (value) {
						for (var i = 0; i < value.length; i++) {
							self.values.push(value[i]);
						}
					}
					break;
				case 'array':
					value = JSON.parse(value);
					if (value) {
						for (var item in value) {
							if (value.hasOwnProperty(item)) {
								self.values.push(value[item]);
							}
						}
					}
					break;
				case 'taxonomy':
				case 'meta':
				case 'date':
					value = JSON.parse(value);
					self.defQuery = value;
					bus.$emit('updateValues', 'query-tree', self.defQuery);
					break;
			}
		},
		error: function(type) {
			this.errorShow = false;
			this.$refs.inputValueArg.focus();
			switch (type) {
				case 'badInput':
					this.errorMsg = sm.errorBadInput;
					break;
				case 'duplicates':
					this.errorMsg = sm.errorDuplicatesValues;
					break;
				default:
					this.errorMsg = sm.errorDefault;
					break;
			}
			this.errorShow = true;
		},
		validate: function() {
			var valid = true;
			var value = this.valueInput;
			var error = this.error;
			if (value === "") {
				error('badInput');
				return false;
			}
			if ( this.currentType == 'year' && ( !/^((19|20)\d{2}|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '' ) ) {
				error('badInput');
				return false;				
			}
			if ( this.currentType == 'month' && ( !/^(1[0-2]|[1-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '' ) ) {
				error('badInput');
				return false;				
			}
			if ( this.currentType == 'week' && ( !/^(5[0-3]|[1-4][0-9]|[0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '' ) ) {
				error('badInput');
				return false;				
			}
			if ( this.currentType == 'day' && ( !/^([1-9]|[1-2][0-9]|3[0-1]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '' ) ) {
				error('badInput');
				return false;				
			}
			if ( this.currentType == 'hour' && ( !/^(2[0-3]|1[0-9]|[0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '' ) ) {
				error('badInput');
				return false;				
			}
			if ( this.currentType == 'minute' && ( !/^(5[0-9]|[0-9]|[1-4][0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '' ) ) {
				error('badInput');
				return false;				
			}
			if ( this.currentType == 'second' && ( !/^(5[0-9]|[0-9]|[1-4][0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '' ) ) {
				error('badInput');
				return false;				
			}
			if ( this.currentType == 'yearmonth' && ( !/^((19|20)\d{2}(1[0-2]|0[1-9])|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '' ) ) {
				error('badInput');
				return false;				
			}
			if (!this.editMode) {
				this.values.filter(function(row) {
					if (row == value ) {
						error('duplicates');
						valid = false;
					}
				});
			}
			return valid;
		}
	}
};
</script>


// WEBPACK FOOTER //
// QueryBuilder.vue?7998336c